import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from "@angular/router";
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../../services/users/users.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  constructor(
  private router: Router,
  private SpinnerService: NgxSpinnerService,
  private toastr: ToastrService,
  private UsersService: UsersService,) { }

  register(user : NgForm){
    console.log(user);
    if(!user || !user.valid) return;
    var userToSend ={
      user:user.form.value
    }
    this.UsersService.register(userToSend).then((result:any)=>{
      if(result.msg=='you are already registered '){
        this.toastr.error(result.msg);
      }
      else  {
        var user = {email:userToSend.user.email,password:userToSend.user.password};
        this.UsersService.login(user).then((result:any)=>{
          if(result.msg=='you are already registered '){
            this.toastr.error(result.msg);
          }
          else  this.router.navigate(['image-editor']);
        });
      }
    }).catch((err)=>{
      err = err || new Object();
    });
  }

  ngOnInit(): void {
  }

}
